import React from 'react';
import { SearchAction } from './reducers/SearchActions';

const useSearchReload = (dispatch: React.Dispatch<SearchAction>) => {
    React.useEffect(function handleNavigation() {
        window.addEventListener('popstate', reloadData);

        return function cleanup() {
            window.removeEventListener('popstate', reloadData);
        };

        function reloadData() {
            dispatch({ type: 'reload' });
        }
    }, []);
};

export { useSearchReload };
